export default __webpack_public_path__ + "static/media/249.4254ea20.jpg";